import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiErrorDetail, LOGO_FULL } from "@/lib/api";
import { PasswordInput } from "@/pages/AdminLogin";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) {
      setError("Passwords do not match.");
      return;
    }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      toast.success("Password updated — please sign in.");
      navigate("/admin/login", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-ink text-sand grid place-items-center px-5" data-testid="reset-password-page">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <img src={LOGO_FULL} alt="Mahadinusa Lembongan logo" className="w-44 mx-auto mb-4" />
          <h1 className="font-serif text-2xl">Set a new password</h1>
        </div>
        {!token ? (
          <div className="bg-sand text-ink rounded-3xl p-7 shadow-2xl text-sm text-center" data-testid="reset-password-invalid">
            This reset link is missing its token. Ask the admin to generate a new one.
            <Link to="/admin/login" className="block mt-4 text-azure hover:underline" data-testid="reset-password-back-link">← Back to sign in</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="bg-sand text-ink rounded-3xl p-7 shadow-2xl space-y-4" data-testid="reset-password-form">
            <PasswordInput value={password} onChange={(e) => setPassword(e.target.value)} testid="reset-password-new-input" label="New password" placeholder="Minimum 8 characters" />
            <PasswordInput value={confirm} onChange={(e) => setConfirm(e.target.value)} testid="reset-password-confirm-input" label="Confirm password" />
            {error && <p className="text-sm text-coral" data-testid="reset-password-error">{error}</p>}
            <button
              type="submit"
              disabled={busy}
              data-testid="reset-password-submit"
              className="w-full rounded-xl bg-ink text-sand text-sm font-medium py-3 hover:bg-azure disabled:opacity-60"
            >
              {busy ? "Saving…" : "Save new password"}
            </button>
            <Link to="/admin/login" className="block text-center text-xs text-seastone hover:text-ink" data-testid="reset-password-back-link">
              ← Back to sign in
            </Link>
          </form>
        )}
      </div>
    </div>
  );
}
